import React from 'react';
import {GENDER_OPTIONS} from '../constants';
import {StepProps, asRecord, stringField} from './types';

/**
 * Шаг «Немного о вас» (слот 4): пол, возраст, рост, вес. Поля и их границы — те же, что в
 * настройках профиля (`UserPreferencesSection`), чтобы мастер и профиль не расходились;
 * при завершении мастера значения уезжают в те же колонки `UserSettings`.
 */
const NUMERIC_FIELDS: {field: string; label: string; min: number; max: number; unit?: string}[] = [
    {field: 'ageYears', label: 'Возраст', min: 10, max: 120},
    {field: 'heightCm', label: 'Рост, см', min: 50, max: 280},
    {field: 'weightKg', label: 'Вес, кг', min: 1, max: 500},
];

const StepProfile: React.FC<StepProps> = ({value, onChange}) => {
    const current = asRecord(value);

    const update = (field: string, raw: string) => {
        const next = {...current};
        if (raw === '') {
            delete next[field];
        } else {
            next[field] = field === 'gender' ? raw : Number(raw);
        }
        onChange(next);
    };

    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-testid="onboarding-step-profile">
            <label className="flex flex-col gap-1">
                <span className="text-sm text-gray-700 dark:text-gray-300">Пол</span>
                <select
                    value={stringField(value, 'gender')}
                    onChange={e => update('gender', e.target.value)}
                    className="input-field min-h-[44px]"
                    data-testid="onboarding-profile-gender"
                >
                    {GENDER_OPTIONS.map(opt => (
                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                    ))}
                </select>
            </label>
            {NUMERIC_FIELDS.map(f => (
                <label key={f.field} className="flex flex-col gap-1">
                    <span className="text-sm text-gray-700 dark:text-gray-300">{f.label}</span>
                    <input
                        type="number"
                        inputMode="numeric"
                        min={f.min}
                        max={f.max}
                        value={stringField(value, f.field)}
                        onChange={e => update(f.field, e.target.value)}
                        className="input-field min-h-[44px]"
                        placeholder="—"
                        data-testid={`onboarding-profile-${f.field}`}
                    />
                </label>
            ))}
        </div>
    );
};

export default StepProfile;
